// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import { apiProxy, apiUrl } from './index';
import { IPageParams, IPageResult, adaptPageParams, adaptPageResult } from './utils';

export async function fetchLogs(params: IPageParams): Promise<API.ListResult> {
  const res = await request<IPageResult>(`${apiProxy}${apiUrl.logs}`, {
    method: 'GET',
    params: adaptPageParams(params),
  });
  return adaptPageResult(res);
}

export async function fetchLogTypes(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.logTypes}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function fetchLogUsers(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.logUsers}`, {
    method: 'GET',
    ...(options || {}),
  });
}
